export function AuroraBackground() {
  return (
    <div
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-aurora-base"
      aria-hidden
    >
      <div
        className="absolute -top-[20%] left-1/2 h-[60vmin] w-[80vmin] -translate-x-1/2 rounded-full opacity-[0.08] blur-[120px]"
        style={{ background: "radial-gradient(circle, var(--primary) 0%, transparent 70%)" }}
      />
    </div>
  );
}
